module.exports = __webpack_public_path__ + "static/img/zhbg.3e8fe9ea.png";